export default class PPHelper {
    static getFeeSlab(slabList: any[],outstandingAmount: number) {
        return slabList.reduce((acc, curItem) => {
            if (outstandingAmount > curItem.minGreater && outstandingAmount <= curItem.maxLessEquals) {
              acc = curItem.feeAmount;
            }
            return acc;
          }, 0);
    }
}